import React from 'react'

export default function Badge({
  intent = 'secondary',
  className = '',
  ...props
}) {
  return <span {...props} className={`${className} badge badge-${intent}`} />
}
